import { render, staticRenderFns } from "./Parents.vue?vue&type=template&id=6998c974&"
import script from "./Parents.vue?vue&type=script&lang=js&"
export * from "./Parents.vue?vue&type=script&lang=js&"
import style0 from "./Parents.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports